const sidebarLocale = {
  toggleSidebar: "Toggle Sidebar"
};
export {
  sidebarLocale
};
//# sourceMappingURL=en_US.js.map
